import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '=',
        filter: '=',
        trainerSearch: '=',
        showFilter: '='
    },
    template: `
        <div class="table-filters">
            <form class="form form-filter" ng-if="vm.showFilter===true" ng-submit="vm.applyFilter()">
                <div class="fields">
                    <div class="row">
                        <label class="label">{{ 'filter.Type' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.type" ng-options="key as item for (key, item) in vm.COURSE_TRAINING_TYPE_ENUM.LABELS">
                            <option value="">{{ 'filter.All' | translate }}</option>
                        </select>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Course' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.course" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row row-separated">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.departmentId" ng-options="item.id as item.value for item in vm.departments">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Role' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.roleId" ng-options="item.id as item.value for item in vm.roles">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Level' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.levelId" ng-options="item.id as item.value for item in vm.levels">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Trainer/Training Company' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.trainerSearch" type="text" class="form-control">
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    <button type="submit" class="hidden" >{{ 'filter.Filter' | translate }}</button>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor (uiCalendarConfig, lodash, COURSE_TRAINING_TYPE_ENUM, CLASSIFIER_ENUM, CalendarService) {
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.CalendarService = CalendarService;
        this.uiCalendarConfig = uiCalendarConfig;
        this.lodash = lodash;
        this.departments = this.classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
    }

    applyFilter () {
        this.filter = this.lodash.assign(this.filter, { trainerSearch: this.trainerSearch });

        this.CalendarService.updateEvents(this.filter, (events) => {
            this.uiCalendarConfig.calendars.trainings.fullCalendar('removeEvents');
            this.uiCalendarConfig.calendars.trainings.fullCalendar('renderEvents', events);
        });
    }

    resetFilter () {
        this.trainerSearch = null;
        this.filter = {
            startDate: this.filter.startDate,
            endDate: this.filter.endDate,
            trainerSearch: null
        };
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/planning/filter/calendar/index.js